export default "__VITE_ASSET__BNl6Juru__"